import React from 'react'
import { Grid, TextField } from '@mui/material'
import { useFormContext } from 'react-hook-form'

const LinkTabContent = () => {
  const methods = useFormContext()
  const { register, formState: { errors } } = methods

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label="Title"
          {...register('title', { required: { value: true, message: 'Invalid Title' } })}
          error={!!errors?.title}
          helperText={errors.title?.message}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Link Url"
          {...register('link', { required: { value: true, message: 'Invalid Link' } })}
          error={!!errors?.link}
          helperText={errors.link?.message}
          fullWidth
        />
      </Grid>
    </Grid>
  )
}

export default LinkTabContent
